import { IPagination } from 'app/types/common';

export interface ITeamPaymentRequestMetric {
  pendingPaymentCollectionsTotalCount: number;
  paidPaymentCollectionsTotalCount: number;
  overduePaymentCollectionsTotalCount: number;
  pendingPaymentCollectionsTotalAmount: number;
  paidPaymentCollectionsTotalAmount: number;
  overduePaymentCollectionsTotalAmount: number;
  user: any;
  teams: any;
}

export interface ITeamPaymentRequestMetricsState {
  readonly teamPaymentRequestMetricsById?: any;
  readonly teamPaymentRequestMetricIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPaymentIds?: string[];
  readonly currentTeamPaymentRequestMetricId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
  error?: string;
}

export interface ITeamPaymentRequestMetricsSelector
  extends ITeamPaymentRequestMetricsState {
  readonly currentTeamPaymentRequestMetric?: ITeamPaymentRequestMetric;
  readonly currentFormTeamPaymentRequestMetric?: any;
}

export enum TeamPaymentRequestMetricsActionTypes {
  GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_REQUESTED = 'redux-app/team-payment-request-metrics/GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_REQUESTED',
  GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_PENDING = 'redux-app/team-payment-request-metrics/GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_PENDING',
  GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_SUCCESS = 'redux-app/team-payment-request-metrics/GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_SUCCESS',
  GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_FAIL = 'redux-app/team-payment-request-metrics/GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_FAIL',
}

export default null;
